import { getCurrentInstance as n } from "vue";
function t() {
  return n() !== null;
}
const r = typeof window < "u";
export {
  t as hasInstance,
  r as isBrowser
};
